import { ID } from './utils';

export interface IInviteResponse {
  success: boolean;
  message?: string;
}

export type AuthTokens = {
  userId: ID;
  accessToken: string;
  refreshToken: string;
};
